import { simplePaymentsPatientHttpClient } from "../api";

const getPreverificationDetails = async (paymentRequestToken) => {
  let result = "";

  await simplePaymentsPatientHttpClient
    .get(`/pay/preverificationdetails/${paymentRequestToken}`)
    .then((response) => {
      result = response.data;
    });

  return result;
};

const validatePaymentRequest = async (paymentRequestToken, data) => {
  let result = "";

  await simplePaymentsPatientHttpClient
    .post(`/pay/verify/${paymentRequestToken}`, data, { timeout: 60000 })
    .then((response) => {
      result = response.data;
    });

  return result;
};

const getPaymentDetails = async (paymentRequestToken) => {
  let result = "";

  await simplePaymentsPatientHttpClient
    .get(`/pay/paymentdetails/${paymentRequestToken}`, { timeout: 60000 })
    .then((response) => {
      result = response.data;
    });

  return result;
};

const addPaymentActivity = async (
  paymentRequestToken,
  paymentActivityRequest
) => {
  let result = "";

  await simplePaymentsPatientHttpClient
    .post(`/pay/activity/${paymentRequestToken}`, paymentActivityRequest, {
      timeout: 60000,
    })
    .then((response) => {
      result = response.data;
    });

  return result;
};

const makeCreditCardSale = async (paymentRequestToken, data) => {
  let result = "";

  await simplePaymentsPatientHttpClient
    .post(`/pay/sale/${paymentRequestToken}`, data, { timeout: 60000 })
    .then((response) => {
      result = response.data;
    });

  return result;
};

const getReceiptInfo = async (paymentRequestToken) => {
  let result = "";

  await simplePaymentsPatientHttpClient
    .get(`/pay/receipt/info/${paymentRequestToken}`, { timeout: 60000 })
    .then((response) => {
      result = response.data;
    });

  return result;
};

export default {
  getPaymentDetails,
  getPreverificationDetails,
  makeCreditCardSale,
  validatePaymentRequest,
  addPaymentActivity,
  getReceiptInfo,
};
